import React from 'react';
import { cn } from '@/lib/utils';
import { Inbox, LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: LucideIcon;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'No data available',
  description = 'There are currently no items to display.',
  icon: Icon = Inbox,
  action,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center p-8 text-center rounded-lg border border-dashed border-[var(--border-default)] bg-[var(--bg-surface-elevated)]/20 animate-scale-in',
        className
      )}
    >
      <div className="p-3 rounded-full bg-[var(--bg-surface-elevated)] border border-[var(--border-default)] text-[var(--text-dim)] mb-3">
        <Icon className="w-6 h-6 stroke-[1.5]" />
      </div>
      <h4 className="text-sm font-medium text-[var(--text-primary)] mb-1 font-sans">{title}</h4>
      <p className="text-xs text-[var(--text-muted)] max-w-sm mb-4">{description}</p>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
};
